import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { ContextRoute } from '../app/context'
import { ApplicationState } from '../redux/ApplicationState'
import Router from '../router'
import { SERVICE_ALL } from '../domain/Service'

interface OwnProps extends React.PropsWithChildren<any> {
    className?: string
    style?: React.CSSProperties
    role?: string
    title?: string
    parameters?: string
    route?: string | null
    params?: { [key: string]: string | number | string[] | number[] | undefined } | {}
    query?: { [key: string]: string | number | Array<string | undefined> | number[] | undefined }
    skipHistoryApi?: boolean
    anchor?: string
    supportsAllServices?: boolean
    to?: string
    href?: string
    keepAllUnspecifiedParams: boolean
}

interface StateProps {
    router: Router
    currentRoute: ContextRoute
    defaultService: string
}

type Props = StateProps & OwnProps

class SymfonyLink extends React.Component<Props> {
    public static defaultProps = {
        route: null,
        params: {},
        query: {},
        skipHistoryApi: false,
        anchor: '',
        supportsAllServices: true,
        keepAllUnspecifiedParams: false,
    }

    public render() {
        let currentParams = this.props.currentRoute.parameters
        if (!this.props.keepAllUnspecifiedParams) {
            currentParams = pick(this.props.currentRoute.parameters, ['ts', 'm', 's', 'env', 'st', 'status'])
        }
        const param = {
            ...this.props.currentRoute.urlParameters,
            ...currentParams,
            ...this.props.params,
            ...this.props.query,
        }

        if (!this.props.supportsAllServices && param.s === SERVICE_ALL) {
            param.s = this.props.defaultService
        }

        const {
            router,
            currentRoute,
            route,
            params,
            query,
            children,
            dispatch,
            skipHistoryApi,
            anchor,
            defaultService,
            supportsAllServices,
            keepAllUnspecifiedParams,
            ...restProps
        } = this.props

        const actualRoute = route ? route : currentRoute.route

        const url = this.props.router.path(actualRoute, param)

        if (this.props.to || this.props.href) {
            throw new Error("Use route parameter with Symfony route ID to link '" + (this.props.to || this.props.href) + "'")
        }

        if (this.props.skipHistoryApi || router.shouldSkipHistoryApi(actualRoute)) {
            return (
                <a href={url + this.props.anchor} {...restProps}>
                    {this.props.children}
                </a>
            )
        }

        return (
            <Link to={url} {...restProps}>
                {this.props.children}
            </Link>
        )
    }
}
const pick = (object, keys) => {
    return keys.reduce((obj, key) => {
        if (object && Object.prototype.hasOwnProperty.call(object, key)) {
            obj[key] = object[key]
        }
        return obj
    }, {})
}
export default connect<StateProps, OwnProps>((globalState: ApplicationState, props: OwnProps) => {
    return {
        ...props,
        router: globalState.tidewaysContext.router,
        currentRoute: globalState.tidewaysContext.route,
        defaultService: globalState.tidewaysContext.application ? globalState.tidewaysContext.application.defaultService : '',
    }
})(SymfonyLink)
